// src/pages/FoundingMembers.jsx
"use client"; // ✅ genuine wajah se zaroori hai — useState/useEffect/useRef use ho rahe hain
import "@/i18n";
import { useEffect, useState, useRef } from "react";
import FoundingMemberMainSection from "@/components/FoundingMemberMainSection";
import FounderMemberSection from "@/components/FounderMemberSection";
import SupportSection from "@/components/SupportSection";
import UrgencyBanner from "@/components/UrgencyBanner";
import OnboardingTimeline from "@/components/OnboardingTimeline";
import TestimonialsStatsFounderMember from "@/components/TestimonialsStatsFounderMember";
import FooterWithCTA from "@/components/FooterWithCTA";
import FAQS from "@/components/FAQS";
import StillHaveQuestions from "@/components/StillHaveQuestions";
import ExpectedTimeline from "@/components/ExpectedTimeline";

export default function FoundingMember() {
  const [offersData, setOffersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 👉 create ref for FoundingMemberMainSection
  const mainSectionRef = useRef(null);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://www.super-admin.getgeek.ai/nest_backend/offers/active",
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("API Response:", data);
        setOffersData(data);

        if (typeof window !== "undefined") {
          localStorage.setItem("offersData", JSON.stringify(data));
          console.log("Data saved to localStorage");
        }

        setError(null);
      } catch (err) {
        console.error("Error fetching offers:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  // 👉 Scroll handler
  const scrollToMainSection = () => {
    if (mainSectionRef.current) {
      mainSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      {/* Pass the ref to your section */}
      <div ref={mainSectionRef}>
        <FoundingMemberMainSection offersData={offersData} />
      </div>

      <FounderMemberSection offersData={offersData} />
      <TestimonialsStatsFounderMember />
      <OnboardingTimeline onClaimClick={scrollToMainSection} />

      {/* Pass the scroll function to UrgencyBanner */}
      <UrgencyBanner onClaimClick={scrollToMainSection} />
      <FAQS />
      <StillHaveQuestions onClaimClick={scrollToMainSection} />
      <FooterWithCTA />
    </div>
  );
}